import { validate360User } from '../services';
export async function validateAnalyticsUser(login, password) {
    const response = await validate360User(login, password);
    return formatResponse(response);
}
function formatResponse({ success, errors, data }) {
    if (!success) {
        return {
            success: false,
            error: errors.code,
        };
    }
    return {
        success: true,
        data: {
            id: data.id,
            name: data.name,
            imported: data.imported,
            createdAt: data.created_at,
            accessToken: data.access_token,
        },
    };
}
